var exports = {
  "item": "x7f9a0e16--1c3e55--item",
  "image": "x7f9a0e16--1c3e55--image",
  "image-step-1": "x7f9a0e16--1c3e55--image-step-1",
  "image-step-2": "x7f9a0e16--1c3e55--image-step-2",
  "image-step-3": "x7f9a0e16--1c3e55--image-step-3",
  "image-step-4": "x7f9a0e16--1c3e55--image-step-4",
  "image-step-5": "x7f9a0e16--1c3e55--image-step-5",
  "content": "x7f9a0e16--1c3e55--content",
  "title": "x7f9a0e16--1c3e55--title",
  "description": "x7f9a0e16--1c3e55--description",
  "item-ltr": "x7f9a0e16--1c3e55--item-ltr",
};

module.exports = exports;
